module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.displayError) ? _c('p', {
    staticClass: "error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.displayError))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.cash) ? _c('section', [(_vm.cash_total_balance < 0) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_c('div', {
    staticClass: "alert alert-secondary col-12 col-md-5",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v("\n        zpracování během 1-2 pracovních dnů\n        "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "udaje-pro-platbu"
  }, [_c('nobr', [_vm._v("číslo účtu: "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v("344355366")])]), _c('br'), _vm._v("\n            kód banky: "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v("2010")]), _c('br'), _vm._v(" "), _c('nobr', [_vm._v("variabilní symbol: "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v(_vm._s(_vm.$store.state.customerInfo ? _vm.$store.state.customerInfo.id : ''))])]), _c('br'), _vm._v(" "), (_vm.amountOverdue > 0) ? _c('div', {
    staticClass: "text-danger"
  }, [_c('nobr', [_vm._v("dlužná částka (po splatnosti): "), _c('b', [_vm._v(_vm._s(_vm.prachy_bez_00(_vm.amountOverdue)))]), _vm._v(" Kč")])], 1) : _vm._e(), _vm._v(" "), (_vm.amountIndue > 0) ? _c('div', [_vm._v("\n              platba na přístí období: "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v(_vm._s(_vm.prachy_bez_00(_vm.amountIndue)))]), _vm._v(" Kč\n            ")]) : _vm._e(), _vm._v(" "), (_vm.amountOverdue > 0 && _vm.amountIndue > 0) ? _c('div', [_c('nobr', [_vm._v("celkem: "), _c('span', {
    staticClass: "mutable"
  }, [_c('b', [_vm._v(_vm._s(_vm.prachy_bez_00(_vm.amountOverdue + _vm.amountIndue)))])]), _vm._v(" Kč")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.customerInfo && _vm.$store.state.customerInfo.id && (_vm.amountOverdue == 0 || _vm.amountIndue == 0)) ? _c('div', {
    staticClass: "qr-platba"
  }, [_c('img', {
    attrs: {
      "width": "125px",
      "height": "125px",
      "src": ("/api/spayd-qr-code.png?accountNumber=344355366&bankCode=2010&amount=" + (_vm.amountIndue+_vm.amountOverdue) + "&&vs=" + (_vm.$store.state.customerInfo.id) + "&message=Rychly+drat+QR")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-secondary col-12 col-md-6",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "mt-0"
  }, [_vm._v("platba kartou")]), _vm._v(" "), _c('hr'), _vm._v("\n            zpracování během 15 minut\n            "), _c('hr'), _vm._v(" "), (_vm.amountOverdue > 0) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v("\n              dlužná částka (po splatnosti): "), _c('b', [_vm._v(_vm._s(_vm.prachy_bez_00(_vm.amountOverdue)))]), _vm._v(" Kč\n            ")]) : _vm._e(), _vm._v(" "), (_vm.amountIndue > 0) ? _c('div', [_vm._v("\n              platba na přístí období: "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v(_vm._s(_vm.prachy_bez_00(_vm.amountIndue)))]), _vm._v(" Kč\n            ")]) : _vm._e(), _vm._v(" "), (_vm.onlinePaymentSurcharge !== 0) ? _c('div', [_vm._v("\n              expresní zpracování platby: "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v(_vm._s(_vm.prachy_bez_00(_vm.onlinePaymentSurcharge)))]), _vm._v(" Kč\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [(_vm.amountOverdue > 0) ? _c('button', {
    staticClass: "btn btn-primary mr-5",
    attrs: {
      "name": "pay1",
      "type": "submit",
      "disabled": _vm.createOrderPending
    },
    on: {
      "click": function($event) {
        _vm.zaplatitKartou(_vm.amountOverdue + _vm.onlinePaymentSurcharge)
      }
    }
  }, [_vm._v("\n                Zaplatit "), _c('strong', [_vm._v(_vm._s(_vm.prachy_bez_00(_vm.amountOverdue + _vm.onlinePaymentSurcharge)))]), _vm._v(" Kč\n                "), _c('br'), _vm._v(" "), _c('small', [_vm._v("dlužná částka")])]) : _vm._e(), _vm._v(" "), (_vm.amountIndue > 0) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "name": "pay2",
      "type": "submit",
      "disabled": _vm.createOrderPending
    },
    on: {
      "click": function($event) {
        _vm.zaplatitKartou(_vm.amountOverdue + _vm.onlinePaymentSurcharge + _vm.amountIndue)
      }
    }
  }, [_vm._v("\n                Zaplatit "), _c('strong', [_vm._v(_vm._s(_vm.prachy_bez_00(_vm.amountOverdue + _vm.onlinePaymentSurcharge + _vm.amountIndue)))]), _vm._v(" Kč\n                "), _c('br'), _vm._v(" "), _c('small', [(_vm.amountOverdue > 0) ? _c('span', [_vm._v("dlužná částka + ")]) : _vm._e(), _vm._v("na příští období")])]) : _vm._e()])])])])]) : _c('div', {
    staticClass: "row justify-content-around"
  }, [_c('div', {
    staticClass: "alert alert-secondary col-12 col-md-5"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": "/static/rd-images/banka.svg",
      "alt": "bankovní převod"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "mt-0"
  }, [_vm._v("platba bankovním převodem")]), _vm._v(" "), _c('p', [_vm._v("\n              Platby prosím poukazujte na:"), _c('br'), _vm._v("\n                číslo účtu "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v("344355366")]), _c('br'), _vm._v("\n                kód banky "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v("2010")]), _c('br'), _vm._v("\n                variabilní symbol "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v(_vm._s(_vm.$store.state.customerInfo ? _vm.$store.state.customerInfo.id : ''))]), _vm._v(" "), _c('br'), _vm._v("\n              Děkujeme.\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-secondary col-12 col-md-6",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "mt-0"
  }, [_vm._v("platba kartou")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n                ✅ vše zaplaceno, děkujeme.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Platba na příští období bude předepsána " + _vm._s(_vm.dateNextMonthFirst) + ".")])])])])])]), _vm._v(" "), _c('h2', [_vm._v("historie účtu\n      "), (_vm.cash.length > 10) ? _c('small', [(_vm.displayLast10) ? _c('span', [_vm._v("\n          - posledních 10 položek\n          "), _c('button', {
    staticClass: "btn btn-outline-primary",
    on: {
      "click": function($event) {
        _vm.displayLast10 = false
      }
    }
  }, [_vm._v("zobrazit vše")])]) : _c('span', [_vm._v("\n          - vše od " + _vm._s(_vm.human_readable_date(_vm.cash[0].createTs)) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_vm._l(((_vm.displayLast10 ? _vm.cash.slice(-10) : _vm.cash)), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.human_readable_date(item.createTs)) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [(item.value < 0) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.human_readable_date(item.date)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "money",
      staticStyle: {
        "width": "7%"
      }
    }, [(item.value < 0) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.prachy(-item.value)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "money",
      staticStyle: {
        "width": "7%"
      }
    }, [(item.value >= 0) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.prachy(item.value)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "money",
      class: {
        'number-below-zero': item.after < 0
      },
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.prachy(item.after)) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "65%"
      }
    }, [_vm._v("\n            " + _vm._s(item.comment) + "\n            "), (item.comment2) ? _c('div', {
      staticClass: "comment2"
    }, [_vm._v(_vm._s(item.comment2))]) : _vm._e()])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "bottomline"
  }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "money",
    class: {
      'number-below-zero': _vm.cash_total_balance < 0
    }
  }, [_vm._v("\n            " + _vm._s(_vm.prachy(_vm.cash_total_balance)) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "preplatek-nebo-nedoplatek"
  }, [(_vm.cash_total_balance == 0) ? _c('span', [_vm._v("\n              ✅ vše zaplaceno, děkujeme.\n            ")]) : (_vm.cash_total_balance > 0) ? _c('span', [_vm._v("\n              ✅ (máte přeplaceno)\n            ")]) : _c('span', [_c('div', [_vm._v("částka k úhradě je " + _vm._s(_vm.prachy(-_vm.cash_total_balance)) + " Kč")]), _vm._v(" "), (_vm.overdueAmount > 0) ? _c('div', {
    staticClass: "number-below-zero"
  }, [_vm._v("\n                  z toho " + _vm._s(_vm.prachy(_vm.overdueAmount)) + " Kč je již po splatnosti\n                ")]) : _vm._e()])])])], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "mt-0"
  }, [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": "/static/rd-images/banka.svg",
      "alt": "bankovní převod"
    }
  }), _vm._v("\n          platba bankovním převodem")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', [_vm._v("QR kód pro platbu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": "/static/rd-images/visa.png",
      "alt": "visa",
      "width": "65px"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": "/static/rd-images/mastercard-logo.svg",
      "alt": "mastercard",
      "height": "45px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": "/static/rd-images/visa.png",
      "alt": "visa",
      "width": "65px"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": "/static/rd-images/mastercard-logo.svg",
      "alt": "mastercard",
      "height": "45px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n            datum účtování\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            datum splatnosti\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "money"
  }, [_vm._v("\n            k úhradě\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "money"
  }, [_vm._v("\n            uhrazeno\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "money"
  }, [_vm._v("\n            zůstatek\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            popis\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-617e250d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyAccount.vue
// module id = 308
// module chunks = 1 2